export enum DentalNotation {
  Utn = 1,
  Fdi = 2,
}
